import { Chip, Stack } from "@mui/material";
import React from "react";

const EmployeeDepartmentChips = ({ item }) => {
  const departments = item?.departments;
  return (
    <Stack direction="row" gap="5px">
      {departments?.map(({ id, label }) => (
        <Chip
          key={id}
          label={label}
          sx={{
            "& .MuiChip-label": {
              fontSize: 10,
            },
          }}
        />
      ))}
    </Stack>
  );
};

export default EmployeeDepartmentChips;
